import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ProductGroupFilterMobileComponent } from './product-group-filter-mobile.component';
import { ProductGroupsService } from '@prlw/core/products/product-groups.service';
import { combineLatest, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TMobileListSectionItem } from '@prlw/common/mobile-list-section/mobile-list-section.component';
import { ProductGroupSelectionService } from '../../monitor/product-selection-dialog/product-group-selection.service';

@Component({
  selector: 'prlw-product-group-filter-mobile',
  standalone: true,
  imports: [CommonModule, ProductGroupFilterMobileComponent],
  templateUrl: './product-group-filter-mobile.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGroupFilterMobileContainer {
  @Output() eventClose = new EventEmitter<void>();

  constructor(
    private productGroupsService: ProductGroupsService,
    private productGroupSelectionService: ProductGroupSelectionService,
    private router: Router,
  ) {}

  selectedItems$ = combineLatest([
    this.productGroupsService.currentProductGroup$,
    this.productGroupsService.selectedProductGroups$,
  ]).pipe(
    map(([current, items]) =>
      items.map((item) => ({
        text: item.code,
        subText: item.name,
        icon: `product-${item.code.toLowerCase()}`,
        favorite: true,
        checked: current.code === item.code,
        switchChecked: null,
        allowDragDrop: false,
      })),
    ),
  );

  otherItems$ = combineLatest([
    this.productGroupsService.productGroups$,
    this.productGroupsService.selectedProductGroups$,
  ]).pipe(
    map(([allItems, items]) =>
      allItems
        .filter((allItem) => !items.find((item) => item.code === allItem.code))
        .map((item) => ({
          text: item.code,
          subText: item.name,
          icon: `product-${item.code.toLowerCase()}`,
          favorite: false,
          checked: null,
          switchChecked: null,
          allowDragDrop: false,
        })),
    ),
  );

  selectProductGroup(item: TMobileListSectionItem) {
    this.router.navigate([`/monitor/${item.text}`]);
    this.eventClose.emit();
  }

  public handleProductGroupSelected(item: TMobileListSectionItem): void {
    this.productGroupSelectionService.selectProductGroup({
      name: item.subText ?? '',
      code: item.text,
    });
  }

  public handleProductGroupUnselected(item: TMobileListSectionItem): void {
    if (item.checked) return;
    this.productGroupSelectionService.unselectProductGroup({
      name: item.subText ?? '',
      code: item.text,
    });
  }
}
